<template>
  <v-container>
    <v-row>
      <v-col>
        <client-email-activity :userId="userId"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <client-notes :userId="this.userId" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClientEmailActivity from "./communication/ClientEmailActivity";
import ClientNotes from "./communication/ClientNotes";

export default {
  name: "ClientCommunication",
  components: {
    ClientEmailActivity,
    ClientNotes
  },
  props: ["userId"],
}
</script>

<style scoped>

</style>